<template>
	<div class="k-main-collection">
		<h1 class="k-page-title d-flex">
			<k-icon color="primary" class="mr-4" large>{{ support_icon.icon }}</k-icon>
			<b>{{ support_icon.title }}</b>
			<v-spacer/>
		</h1>

		<div v-html="content"></div>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'SupportPage',

	computed: {
		...mapState(['site_config', 'home_page_content']),

		support_icon() {
			return this.site_config.support_icon
		},

		content() {
			return this.add_fallback_alt_text(this.home_page_content['support_page'])
		}
	},

	created() {
		if (!('support_page' in this.home_page_content)) {
			this.$store.dispatch('get_home_page_content', 'support_page')
		}
	},

	methods: {
		add_fallback_alt_text(html) {
			if (!html) return html
			if (typeof DOMParser == 'undefined') {
				return html
					.replace(/<img\b(?![^>]*\balt=)/gi, `<img alt="${this.site_config.app_name} support page image"`)
					.replace(/<h1\b/gi, '<h2')
					.replace(/<\/h1>/gi, '</h2>')
			}

			let parser = new DOMParser()
			let doc = parser.parseFromString(`<div>${html}</div>`, 'text/html')
			let wrapper = doc.body.firstElementChild
			if (!wrapper) return html

			for (let heading of wrapper.querySelectorAll('h1')) {
				let replacement = doc.createElement('h2')
				for (let attr of heading.attributes) replacement.setAttribute(attr.name, attr.value)
				replacement.innerHTML = heading.innerHTML
				heading.replaceWith(replacement)
			}

			for (let heading of wrapper.querySelectorAll('h1, h2, h3, h4, h5, h6')) {
				let has_text = heading.textContent && heading.textContent.trim().length > 0
				let has_meaningful_media = heading.querySelector('img, svg, picture, video')
				if (!has_text && !has_meaningful_media) heading.remove()
			}

			let img_count = 0
			for (let img of wrapper.querySelectorAll('img')) {
				if (img.hasAttribute('alt')) continue
				img_count += 1
				img.setAttribute('alt', img_count == 1 ? `${this.site_config.app_name} branded image` : `${this.site_config.app_name} support page image`)
			}

			return wrapper.innerHTML
		},
	}
}
</script>
